<template lang="pug">
.l-article-backbtn(
    :class="{hotoke:store.ui.state.hotoke}"
    @click="click"
  )
  
</template>

<style lang="stylus" scoped>
@import '~@/assets/styles/foundation/_variables.styl'

.l-article-backbtn
  wh(40px)
  pos()
  cursor pointer
  no_highlight()
  
  &:before,
  &:after
    content ""
    pos(0,20px)
    background-color #404040
    wh(40px,3px)
  
  &.hotoke:before,
  &.hotoke:after
    background-color #FFF

  &:before
    transform rotate(45deg)
  &:after
    transform rotate(-45deg)

  +pc()
    pos(27px,42px,10)
    transition transform 100ms
    &:hover
      transform scale(1.15)
  +sp()
    pos(37px,37px,10)

</style>


<script>
import { defineComponent, computed, ref, onMounted, reactive } from "vue"
import { useStore } from '@/store'
import { useRoute, useRouter } from 'vue-router'

export default defineComponent({
  name:'ArticleBackBtn',

  components:{},

  setup(props, context) {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()

    const click = ()=> {
      router.push('/')
    }
    return{
      click,
      store
    }
  }
})
</script>
